/**
 * Recursively extract all block component types from a page's components array.
 * Used to preload only the blocks needed for a specific page on navigation.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const extractComponentTypes = (pageData: { components?: any[] }): string[] => {
    const types = new Set<string>();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const traverse = (components: any[]) => {
        for (const comp of components) {
            if (comp.componentType) {
                if (comp.componentType === 'media') {
                    // 'media' is a virtual type — only 'image' and 'video' srcTypes
                    // need their own block chunk. Other srcTypes (icon, emoji, svg)
                    // are rendered inline by their parent block (e.g. List).
                    const srcType = comp.content?.srcType;

                    if (srcType === 'image' || srcType === 'video') {
                        types.add(srcType);
                    }
                } else {
                    types.add(comp.componentType);
                }
            }

            if (comp.components) {
                traverse(comp.components);
            }
        }
    };

    if (pageData.components) {
        traverse(pageData.components);
    }

    return Array.from(types);
};
